let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("isha4")).then(() => parcelRequire('iFoyq'));